import React from "react";
import AsyncSelect from "react-select/async";

export const MultiSelectTagDropdown = ({
  defaultValue = [],
  loadOptions,
  onChange,
}) => {
  return (
    <AsyncSelect
      defaultValue={defaultValue}
      defaultOptions={true}
      isMulti
      loadOptions={loadOptions}
      className="relative z-30"
      onChange={onChange}
    />
  );
};
